// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useCallback, useRef } from "react";
import * as R from "ramda";

import { CriteriaSelect as StyledSegmentValue } from "../CriteriaSelect/styles";
import { Value } from "./styles";
import Dropdown from "./GroupDropdown";
import useBoolean from "src/hooks/useBoolean";
import GroupName from "src/components/Group/Name";
import { RelativeBox } from "src/styles/box";
import { SpacedFlex } from "src/styles/box";
import Icons from "src/icons";

type Props = {
  value: Array<number>,
  handleChange: Function,
};

const SelectGroup = ({ value, handleChange }: Props) => {
  const { value: dropdown, toggleBoolean } = useBoolean();
  const outerRef = useRef();

  const handleSelect = useCallback(
    (id: number) => {
      if (R.includes(id, value)) {
        const newValue = R.reject((val) => val === id, value);
        handleChange(newValue);
      } else {
        handleChange([...value, id]);
      }
    },
    [value, handleChange],
  );

  return (
    <RelativeBox ref={outerRef}>
      <StyledSegmentValue onClick={toggleBoolean}>
        {value.length === 0 && (
          <SpacedFlex>
            <Value>{i18n.t(k.SELECT_GROUP)}</Value>
            <Icons type="caretDown" />
          </SpacedFlex>
        )}

        {value.length !== 0 && (
          <SpacedFlex>
            {value.length === 1 ? (
              <Value>
                <GroupName id={value[0]} />
              </Value>
            ) : (
              <Value>
                {value.length} {i18n.t(k.SELECTED)}
              </Value>
            )}
            <Icons type="caretDown" />
          </SpacedFlex>
        )}
      </StyledSegmentValue>

      {dropdown && (
        <Dropdown
          value={value}
          outerRef={outerRef}
          handleClose={toggleBoolean}
          handleSelect={handleSelect}
        />
      )}
    </RelativeBox>
  );
};

export default SelectGroup;
